"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Griplines = function Griplines(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 11 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 10 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    scale: width / 11,
    viewBox: "0 0 11 10",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,6 L16,6 L16,8 L4,8 L4,6 Z M4,12 L16,12 L16,14 L4,14 L4,12 Z",
    id: "griplines"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Navigation/Top-Nav/Main-Guest",
    transform: "translate(-4.000000, -39.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Molecules/Navigation/Main"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Icon/20px/menu",
    transform: "translate(0.000000, 33.000000)"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    id: "Mask",
    fill: color,
    fillRule: "evenodd",
    xlinkHref: "#griplines"
  }))))));
};

var _default = Griplines;
exports["default"] = _default;
module.exports = exports["default"];